import * as React from 'react';
import { useEffect,useState } from 'react';
import { useLocation } from "react-router-dom";
import PersonService from '../services/person.service';
import PersonDetailsComponent from './PersonDetails.Component';
import {IPerson } from '../@types/Person';
import {IsPerson} from '../helpers/checkIsType';
import { handleHttpError } from '../helpers/HttpErrorHandler';

const SearchComponent:React.FC = () => {

    let defaultPerson: IPerson = { name:'',site:'' ,gender:'' ,siteCode:'' ,profilePicUrl:'' ,personUrl:'',
                                lastSeen:new Date(), lastSeenMsg:'',isOnline:false, hotDealPercent:0,numberOfImages:0,images:[],tags:[],aka:''}; 

    const location = useLocation();
    const site = location.pathname.split("/")[2];
    const name = location.pathname.split("/")[3];
    const [person,popPersonData] = React.useState<IPerson>(defaultPerson);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>();

    const personService = PersonService.getInstance();

    useEffect(()=>{ 
      document.title = 'Camgirl model search results for ' + name;
      let descMeta=document.querySelector("meta[name='description']");
      if(descMeta!==null)descMeta.setAttribute("content", 'Camgirl finder by model name. Search results for camgirl ' + name);
      let canNAme=document.querySelector("link[rel='canonical']");
      if(canNAme!==null)canNAme.setAttribute("href", 'https://www.camgirlcrawler.net/' + location.pathname);

        setLoading(true);

        personService.getPersonDetails(site,name).then(response => { 
          if(IsPerson(response)){ 
            popPersonData(response);
          }else{
              setErrorMsg(handleHttpError(response));
          } 
        }).catch(error => {
          setErrorMsg(handleHttpError(500));
        }).then(() =>{
              setLoading(false);
        });
       }, []); // empty array means only once

       function openInNewTab(url:string){
        window.open(url, "_blank", "noreferrer");
      };

    return (
        <div>
          <div style={{marginTop: '30px'}}>  
              <a href="https://www.latinalovely.cam/" rel="sponsored"  target='_blank' >		  
                <picture>
                  <source media="(max-width:768px)" srcSet="images/latinalovely-420x80.gif"/>
                      <img src="images/latinalovely.gif" alt="Latina lovely sex webcam site" max-width="600px" height="auto"/>
                </picture>
                </a>  
            </div>
            <h1 style={{marginTop:'50px'}}>{person.name}</h1>
            <div>{loading && (                       
                  <img src={'images/spinner.gif'} alt="Loading"  width={'25px'}/>
                  )}
            </div>  
            {errorMsg && (
              <div className="alert alert-danger errorMessage" role="alert">
                {errorMsg}
              </div>
              )}
            {!errorMsg && !loading && (
            <div>
            <div className='resultsThumbsOutter' style={{marginTop:'10px'}}>
                <PersonDetailsComponent key={person.profilePicUrl}  person={person} imgWidth={'450'} imgHeight={'450'}/>
            </div>
            <div style={{marginTop:'30px'}}> 
            <button className="btn btn-success"  onClick={() => openInNewTab(person.personUrl)} style={{cursor:'pointer'}}>
                          Visit {person.name}
            </button>
            </div>
            </div>
            )} 
            <div className='info' style={{marginTop:'75px'}}>
            <section>
              <h2>Cam girl face search results explainer:</h2>
                <div className='explainer'>
                    <picture>
                      <source type="image/webp" srcSet ="images/explainer.webp"/>
                      <source type="image/jpg" srcSet ="images/explainer.jpg"/>
                      <img src="images/best_face.jpg" alt="Cam girl search results explainer" style={{marginTop:'30px'}} width={'330px'} height={'354px'}/>
                    </picture>
                    <div>
                      <ol>
                        <li>Web site the cam girl performs on.</li>
                        <li>% likely it's a match. 100% is a perfect match.</li>
                        <li>Gender, this is not 100% reliable.*</li>
                        <li>The last time our crawler saw the cam girl online</li>
                      </ol>
                    </div>
                </div>     
            </section>
          </div>
        </div>
  );
}
export default SearchComponent;